import { EventPriceDto } from '@sweatpals/shared';
import { isNumber } from 'lodash-es';

export const getMoreExpensivePrices = (prices: EventPriceDto[], price: EventPriceDto) => prices
	.filter(({ maxTickets, ticketsCount = 0 }) => !isNumber(maxTickets) || ticketsCount < maxTickets)
	.filter(p => p.priceAmount > price.priceAmount);
